import { RootState } from 'store/index';
import { useSelector } from 'react-redux';

export const useAllChallenges = () => {
    const challenges = useSelector((state: RootState) => state.prop_myPlans.challenges);
    return challenges;
};
